module.exports = __webpack_public_path__ + "img/cancelar.f2448d23.svg";